/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BankAccountVerificationRequest } from '../models/bank-account-verification-request';


/**
 * API to trigger bank account verification
 */
@Injectable({
  providedIn: 'root',
})
export class BankVerificationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation verifyBankAccount
   */
  static readonly VerifyBankAccountPath = '/bank-verification/{countryCode}';

  /**
   * Trigger bank account verification for a country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyBankAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyBankAccount$Response(params: {
    countryCode: string;
    body: BankAccountVerificationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, BankVerificationService.VerifyBankAccountPath, 'post');
    if (params) {
      rb.path('countryCode', params.countryCode, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Trigger bank account verification for a country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyBankAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyBankAccount(params: {
    countryCode: string;
    body: BankAccountVerificationRequest
  },
  context?: HttpContext

): Observable<string> {

    return this.verifyBankAccount$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
